var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isServiceProviderCatalogOccupationsLoaded)?_c('sliding-tabs',{staticClass:"OCCUPATION-TABS",attrs:{"activeTab":_vm.serviceProviderOccupationName}},[_vm._l((_vm.serviceProviderCatalogOccupations),function({ id, occupation }){return [(occupation.name)?_c('sliding-tabs-content',{key:occupation.name,attrs:{"name":occupation.name,"titleProps":{
          title: occupation.display_name,
          to: {
            name: 'account::pro::occupation',
            params: { serviceProviderOccupationId: id }
          },
        }}}):_vm._e()]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }